var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisacard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 25,
    viewBox: "0 0 40 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 38,
    height: 24,
    rx: 2.5,
    stroke: "#F4F3F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6665 15.3258L27.4977 14.4821H25.6122L25.3123 15.3198L23.801 15.3228C24.5205 13.5927 25.2415 11.8632 25.964 10.1343C26.087 9.84109 26.3053 9.69184 26.627 9.69334C26.873 9.69559 27.2743 9.69559 27.8315 9.69409L29 15.3236L27.6665 15.3258ZM26.0367 13.3263H27.2518L26.798 11.2113L26.0367 13.3263ZM16.295 9.69259L17.8145 9.69409L15.4655 15.3266L13.9273 15.3251C13.5404 13.8373 13.1584 12.3483 12.7812 10.8581C12.7062 10.5611 12.5577 10.3533 12.272 10.2551C12.0178 10.1673 11.594 10.0323 11 9.84859V9.69484H13.4278C13.8477 9.69484 14.093 9.89809 14.1718 10.3151C14.2513 10.7328 14.4507 11.7963 14.7717 13.5056L16.295 9.69259ZM19.9025 9.69409L18.701 15.3251L17.255 15.3236L18.455 9.69259L19.9025 9.69409ZM22.835 9.58984C23.2677 9.58984 23.813 9.72484 24.1265 9.84859L23.873 11.0163C23.5895 10.9023 23.123 10.7486 22.7308 10.7538C22.1607 10.7636 21.8083 11.0028 21.8083 11.2323C21.8083 11.6058 22.4202 11.7941 23.0502 12.2021C23.7695 12.6671 23.864 13.0848 23.855 13.5386C23.8452 14.4806 23.0503 15.4098 21.3733 15.4098C20.6083 15.3986 20.3322 15.3341 19.7083 15.1128L19.9722 13.8941C20.6075 14.1603 20.8767 14.2451 21.4198 14.2451C21.917 14.2451 22.3438 14.0441 22.3475 13.6938C22.3505 13.4448 22.1975 13.3211 21.6395 13.0136C21.0815 12.7053 20.2985 12.2786 20.309 11.4221C20.3217 10.3256 21.3605 9.58984 22.8358 9.58984H22.835Z",
    fill: "#1E51AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisacard);
export default __webpack_public_path__ + "static/media/visacard.c4e1007de598df348465783734cecc22.svg";
export { ForwardRef as ReactComponent };